<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="baseCustomerboxes"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button  v-if="editAuth" type="primary" @click="$refs.editBox.open(0)">新建</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="客户名称">
            <el-input v-model.trim="filter.customerName" clearable/>
          </vm-search>
          <vm-search label="备注">
            <el-input v-model.trim="filter.boxText" clearable/>
          </vm-search>
        </div>
      </template>
<!--      <el-table-column type="selection" align="center" width="55"/>-->
      <el-table-column prop="customerOutNo" align="center" label="客户编号" width="80px"/>
      <el-table-column prop="customerName" align="center" label="客户名称" width="300px"/>
      <el-table-column prop="boxText" align="center" label="备注信息"/>
      <el-table-column prop="creatorName" align="center" label="创建人" width="100px"/>
      <el-table-column prop="createTime" align="center" label="创建时间" width="180px"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px"
          fixed="right">
        <template slot-scope="scope">
          <el-button v-if="editAuth" type="info" @click="$refs.editBox.open(scope.row)">编辑</el-button>
          <el-button v-if="editAuth" type="danger" @click="oneDelete(scope.row)">删除</el-button>
      </template>
      </el-table-column>
    </vm-table>
    <customer-box-edit ref="editBox" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import CustomerBoxEdit from "@/views/information/CustomerBox/CustomerBoxEdit.vue";

  export default {
    name: "CustomerBoxList",
    components: {CustomerBoxEdit, VmTable, VmSearch},
    data() {
      return {
        editAuth: this.$auth(442),
        idList: "",
        exportLoading: false,
        filter: {
          boxText:"",
          customerName: "",
          creatorName: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .delete("basic", "baseCustomerboxes", row.pkid).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },

    },
  };
</script>

<style scoped>

</style>
